import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';
import { IRanksDetailedReportAdminFilterQueryParams } from '../types';

const FETCH_RANKS_DETAILED_REPORT_ADMIN_QUERY_KEY =
  'fetch-ranks-detailed-report-admin-query-key';

/**
 * -----------------------------------------------------------------------------
 * React Query hook for fetching ranks detailed report admin data using
 * `fetchRanksDetailedReportAdmin` API. Provides error, loading, and success
 * state along with the response.
 */
export const useRanksDetailedReportAdminQuery = (
  filter?: IRanksDetailedReportAdminFilterQueryParams
) => {
  const queryKey = [FETCH_RANKS_DETAILED_REPORT_ADMIN_QUERY_KEY, filter];
  const queryFn = () => BIDS_API.fetchRanksDetailedReportAdmin(filter);

  const { data, isError, error, isPending, refetch, isFetching } =
    useQueryWithUserId({
      queryKey,
      queryFn,
      retry: false,
    });

  return {
    data,
    isError,
    error,
    isPending,
    isFetching,
    refetch,
  };
};
